import BadgeAssigneeHome from '@/screens/BadgeAssigneeHome';

export default function PrivateTabsOrganizationBadgeBadgeIdAssigneeIndexRoute() {
  return <BadgeAssigneeHome />;
}
